import axios, { AxiosError } from 'axios';
import { CommonRootState } from '../combineReducers';
import { IOrganizationLink } from '../interfaces/organizationLink';
import { sendError } from '../sendError';
import { ThunkAction } from 'redux-thunk';

const fetchOrganizationLinkRequest = () =>
  ({
    type: 'FETCH_ORGANIZATION_LINK_REQUEST'
  } as const);

const fetchOrganizationLinkSuccess = (payload: IOrganizationLink) =>
  ({
    type: 'FETCH_ORGANIZATION_LINK_SUCCESS',
    payload
  } as const);

const fetchOrganizationLinkFailure = (error: AxiosError) => {
  sendError(error);
  return {
    type: 'FETCH_ORGANIZATION_LINK_FAILURE',
    error
  } as const;
};

const shouldFetchOrganizationLink = (
  { organizationLink: { organizationLink, isFetching } }: CommonRootState,
  pecOrganizationId: string
) => !isFetching && (!organizationLink || organizationLink.pecOrganizationId !== pecOrganizationId);

const fetchOrganizationLink = (
  pecOrganizationId: string
): ThunkAction<Promise<IOrganizationLink>, CommonRootState, null, Actions> => dispatch =>
  new Promise(async (resolve, reject) => {
    try {
      dispatch(fetchOrganizationLinkRequest());

      const {
        data: { value }
      } = await axios.get('/api/v3.01/veriforceOrganizationLinks', {
        params: {
          $filter: `(pecOrganizationId eq ${pecOrganizationId}) and (isDeleted eq false)`
        }
      });

      dispatch(fetchOrganizationLinkSuccess(value[0]));
      resolve(value[0]);
    } catch (error) {
      dispatch(fetchOrganizationLinkFailure(error));
      reject(error);
    }
  });

export const fetchOrganizationLinkIfNeeded = (
  pecOrganizationId: string
): ThunkAction<void, CommonRootState, null, Actions> => (dispatch, getState) => {
  if (shouldFetchOrganizationLink(getState(), pecOrganizationId)) {
    dispatch(fetchOrganizationLink(pecOrganizationId));
  }
};

export type Actions =
  | ReturnType<typeof fetchOrganizationLinkRequest>
  | ReturnType<typeof fetchOrganizationLinkSuccess>
  | ReturnType<typeof fetchOrganizationLinkFailure>;
